/**
 * Created by BETALOS on 27/02/2017.
 */
(function () {

    'use strict';

    class PatientAlertCtrl {
        constructor(notificationService, $mdMenu, $element) {
            this.menu = $mdMenu;
            this.service = notificationService;

            this.btnClass = $element.is('[icon-button]') ? 'md-icon-button' : '';
            this.currentPatient = this.currentPatient ? this.currentPatient : null;
        }

        static get $inject() {
            return ["notificationService", "$mdMenu", "$element"];
        }

        $onInit() {
            // No loadAlerts here: AngularJS always fires $onChanges before $onInit for
            // the initial binding, so loading is handled there (avoids duplicate calls).

            // Subscribe to real-time alert changes. Reload when either:
            //  - our own patient's cache was invalidated
            //  - a global invalidation happened (patientId === null)
            this.alertsSubscription = this.service.observeAlertsChanged()
                .subscribe(event => {
                    const eventPid = event && event.patientId;
                    const concerns = _.isNil(eventPid) || eventPid === this.currentPatient;
                    if (concerns && !_.isNil(this.currentPatient)) this.loadAlerts();
                });
        }

        $onChanges(changes) {
            const patientChanged = changes && changes.currentPatient &&
                changes.currentPatient.currentValue !== changes.currentPatient.previousValue;
            if (patientChanged) this.loadAlerts();
        }

        $onDestroy() {
            if (this.alertsSubscription) this.alertsSubscription.unsubscribe();
        }

        loadAlerts() {
            if (_.isNil(this.currentPatient)) {
                this.alerts = [];
                return;
            }

            this.service.getAlertsForPatient(this.currentPatient)
                .then(data => this.applyAlerts(data), () => this.applyAlerts([]));
        }

        applyAlerts(data) {
            this.alerts = _.orderBy(data || [], this.getLevelOrder, 'desc');
        }

        markAsSeen(alert) {
            this.service.markAlertAsSeen(alert.id)
                .then(() => this.removeAlert(alert))
        }

        removeAlert(alert) {
            const index = _.findIndex(this.alerts, {id: alert.id});
            if (index < 0) return; // already removed by an earlier observed change
            this.alerts.splice(index, 1);

            if (this.alerts.length === 0) this.menu.hide();
        }

        getLevelOrder(alert) {
            switch (alert.level) {
                case 'MINIMUM':
                    return 0
                case 'MEDIUM':
                    return 1
                case 'HIGH':
                    return 2
            }
        }

    }

    module.exports = {
        controllerAs: "vm",
        bindings: {
            currentPatient: "<patient"
        },
        controller: PatientAlertCtrl,
        template: require('frontdesk/views/patient-alert.tpl.html')
    };

})();
